import {Fancybox} from '@fancyapps/ui';


/**
 *
 */
const setupImageGalleries = () =>
{
	Fancybox.bind( ".section-image-gallery [data-fancybox]", {
		hideScrollbar: false,
	} );
};


/**
 *
 */
export default setupImageGalleries;